import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextQuestion from './QuestionType/TextQuestion';
import SelectQuestion from './QuestionType/SelectQuestion';
import UploadQuestion from './QuestionType/UploadQuestion';
import type { BusinessAnswerItemProps, BusinessQuestionProps } from './props';
import makeStyles from '@material-ui/core/styles/makeStyles';
import type { QUESTION_TYPES } from './constants';
import { FILE_TYPES, SELECT_TYPES, TEXT_TYPES } from './constants';
import T from 'i18n-react';

export type QuestionProps = BusinessQuestionProps & {
  answerItem?: BusinessAnswerItemProps,
  answerItems?: Array<BusinessAnswerItemProps>,
  onChange: (
    {
      answerItems?: Array<BusinessAnswerItemProps>,
      answerItem?: BusinessAnswerItemProps,
      valid?: boolean,
      file?: boolean,
    },
    type: QUESTION_TYPES,
  ) => void,
  readOnly?: boolean,
  shrink?: boolean,
};

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(1),
  },
}));

const Question = (props: QuestionProps) => {
  const { query, inputType, helperText, isRequired } = props;

  const classes = useStyles();

  let field;
  if (TEXT_TYPES.includes(inputType)) {
    field = <TextQuestion {...props} />;
  } else if (SELECT_TYPES.includes(inputType)) {
    field = <SelectQuestion {...props} />;
  } else if (FILE_TYPES.includes(inputType)) {
    field = <UploadQuestion {...props} />;
  } else {
    return null;
  }

  return (
    <FormControl fullWidth size="small">
      <FormLabel className={classes.label}>
        {query}
        {isRequired && T.translate('business.required')}
      </FormLabel>
      {field}
      {!TEXT_TYPES.includes(inputType) && !!helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default Question;
